<template>
  <el-dialog title="远程升级" :visible.sync="show" width="1200px" custom-class="fixed-height-dialog" @close="handleClose">
    <div v-loading="loading" class="dialog-content">
      <!-- 升级包信息区 -->
      <el-form :inline="true" class="package-info">
        <el-form-item label="升级包名称">
          <span>{{ packageInfo.name }}</span>
        </el-form-item>
        <el-form-item label="版本">
          <span>{{ packageInfo.version }}</span>
        </el-form-item>
        <el-form-item label="文件大小">
          <span>{{ formatFileSize(packageInfo.size) }}</span>
        </el-form-item>
        <el-form-item label="加密串">
          <span>{{ packageInfo.md5_str }}</span>
        </el-form-item>
      </el-form>

      <!-- 查询表单 -->
      <el-form :inline="true" @keyup.enter.native="toFilter" class="filter-form">
        <el-form-item label="资产码">
          <el-input placeholder="请输入资产码" v-model="filter.assets_code" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" @click="toFilter">查询</el-button>
        </el-form-item>
      </el-form>

      <!-- 表格区域：外层容器负责滚动 -->
      <div class="table-wrapper">
        <el-table header-cell-class-name="table-header-cell" :data="tableData" v-loading="loading" height="100%" style="width: 100%">
          <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
          <el-table-column label="资产码" prop="asset_code" align="center"></el-table-column>
          <el-table-column label="设备名称" prop="re_dev_name" align="center" width="180px"></el-table-column>
          <el-table-column label="设备类型" prop="re_dev_type" align="center" width="180px"></el-table-column>
          <el-table-column label="状态" prop="status_name" align="center" width="80">
            <template slot-scope="{ row }">
              <el-tag type="success" v-if="row.status == 1">在线</el-tag>
              <el-tag type="info" v-else>离线</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="120">
            <template slot-scope="{ row }">
              <el-button type="primary" size="mini" :disabled="row.status != 1" @click="handleUpgrade(row)"> 升级 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="my-pagination">
        <el-pagination
          background
          layout="sizes,total,prev,pager,next,jumper"
          :total="pageParams.total"
          :page-size="pageParams.limit"
          :page-sizes="[5, 10, 50, 100, 500, 1000]"
          :current-page="pageParams.page"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import { getOnlineDevicesForUpgrade, upgradeDevice } from "@/api/dev_upgrade_package"

export default {
  mixins: [pageMixin],
  name: "RemoteUpgradeDialog",
  data() {
    return {
      show: false,
      loading: false,
      packageId: null,
      devTypeValue: null,
      packageInfo: {
        name: "",
        version: "",
        size: null,
        md5_str: ""
      },
      filter: {
        assets_code: ""
      },
      tableData: [],
      // 设备类型映射（需与后端保持一致）
      devTypeOptions: [
        { label: "台区", value: "power_transformer" },
        { label: "一体柜", value: "power_cabinet" },
        { label: "分支箱", value: "power_branch_box" },
        { label: "充电桩", value: "power_charge_pile" }
      ]
    }
  },
  methods: {
    // 对外暴露的方法，由父组件调用（接收完整的升级包对象）
    showDialog(packageRow) {
      console.log("showDialog", packageRow)
      this.packageId = packageRow.ID
      this.devTypeValue = packageRow.dev_type
      // 保存升级包信息用于展示
      this.packageInfo = {
        name: packageRow.name,
        version: packageRow.version,
        size: packageRow.size,
        md5_str: packageRow.md5_str
      }
      this.show = true
      this.filter.assets_code = ""
      this.pageParams.page = 1
      this.getData()
    },
    handleClose() {
      this.show = false
    },
    getData() {
      this.loading = true
      getOnlineDevicesForUpgrade({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        assets_code: this.filter.assets_code || null,
        dev_type: this.devTypeValue
      })
        .then((res) => {
          this.tableData = res.data || []
          this.pageParams.total = res.total || 0
          this.loading = false
        })
        .catch((err) => {
          console.error("获取设备列表失败:", err)
          this.$message.error("获取设备列表失败")
          this.loading = false
        })
    },
    // 升级操作
    handleUpgrade(row) {
      this.$confirm(`确定要对设备【${row.asset_code}】进行远程升级吗？`, "提示", {
        type: "warning"
      })
        .then(() => {
          this.loading = true
          upgradeDevice({
            upgrade_package_id: this.packageId,
            asset_code: row.asset_code
          })
            .then((res) => {
              this.$message.success(res.msg || "升级指令已发送")
              // 可选：刷新列表
              this.getData()
            })
            .catch((err) => {
              console.error("升级失败:", err)
              this.$message.error("升级失败")
            })
            .finally(() => {
              this.loading = false
            })
        })
        .catch(() => {})
    },
    // 格式化文件大小
    formatFileSize(bytes) {
      if (!bytes) return "--"
      const units = ["B", "KB", "MB", "GB"]
      let size = bytes
      let unitIdx = 0
      while (size >= 1024 && unitIdx < units.length - 1) {
        size /= 1024
        unitIdx++
      }
      return `${size.toFixed(2)} ${units[unitIdx]}`
    },
    toFilter() {
      this.pageParams.page = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageParams.limit = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.pageParams.page = val
      this.getData()
    }
  }
}
</script>
<style scoped>
/* 固定弹窗总高 400px，Flex 布局，body 滚动条关闭（内部滚动） */
::v-deep .fixed-height-dialog {
  height: 600px;
  display: flex;
  flex-direction: column;
}
::v-deep .fixed-height-dialog .el-dialog__header {
  flex-shrink: 0;
}
::v-deep .fixed-height-dialog .el-dialog__body {
  flex: 1;
  overflow: hidden; /* 关键：禁止 body 滚动，滚动由内部表格区域负责 */
  padding: 10px 20px;
}

/* 内部主容器，Flex 列布局，让表格区域自动撑满剩余高度 */
.dialog-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.package-info {
  flex-shrink: 0;
  background-color: #f5f7fa;
  padding: 10px;
  margin-bottom: 15px;
  border-radius: 4px;
}
.package-info .el-form-item {
  margin-bottom: 0;
  margin-right: 30px;
}

.filter-form {
  flex-shrink: 0;
  margin-bottom: 10px;
}

.table-wrapper {
  flex: 1;
  min-height: 0; /* 必须：允许 flex 子元素缩小，确保表格区域能正确计算高度 */
  overflow: hidden; /* 实际滚动由内部的 el-table 负责，这里只是防止外层溢出 */
}

/* 分页固定底部 */
.my-pagination {
  flex-shrink: 0;
  margin-top: 10px;
  text-align: right;
}
</style>
